module.exports = __webpack_public_path__ + "img/Principle of Commerce.923ceb4f.svg";